import React from 'react';
import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { createI18nT } from '../i18n.js';

export const uninstallCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  const t = createI18nT();

  return createCommand('uninstall')
    .description(t('site_uninstall_command_def.description'))
    .argument('<package>', t('site_uninstall_command_def.argument.package'))
    .action(async (packageName, _opts, command) => {
      const { renderCommand } = await import('./render-command.js');
      const { UninstallCommand } = await import(
        '../components/UninstallCommand/UninstallCommand.js'
      );

      await renderCommand(
        command,
        services,
        cliVersion,
        <UninstallCommand packageName={packageName} />
      );
    });
};
